import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { CommissionReviewRerunRequest, CommissionReviewRerunResponse } from '@shared/models/commissions/commission-review-rerun.models';
import { BaseService } from '@shared/services/base.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CommissionReviewV2Service extends BaseService {
    constructor(private readonly httpClient: HttpClient, protected readonly injector: Injector) {
        super(injector);
    }

    rerun(jobUuid: string, request: CommissionReviewRerunRequest): Observable<CommissionReviewRerunResponse> {
        const url = `${this.environment.backendUrl}/api/v2/commissions/reviews/${encodeURIComponent(jobUuid)}/rerun`;

        return this.httpClient
            .post<CommissionReviewRerunResponse>(url, request)
            .pipe(catchError((error: HttpErrorResponse) => this.handleRerunError(error)));
    }

    private handleRerunError(error: HttpErrorResponse): Observable<never> {
        const message =
            error.error?.errors?.[0]?.detail ||
            error.error?.detail ||
            error.error?.title ||
            error.error?.message ||
            'Unable to rerun the commission review.';
        abp.message.error(message, 'Commission review rerun failed');
        return throwError(() => error);
    }
}
